import React, { useState } from "react";
import { useForm } from "react-hook-form";
import "./Philanthropy.css";
import confirmationcheck from "./assets/confirmationcheck.png";
import { utag } from "./scripts/useUtag";
import makeRequest from "./scripts/makeRequest";

function PhilanthropyConfirmation() {
    return (
        <div>
            <div className="confirmation-page">
                <img
                    src={confirmationcheck}
                    className="confirmation-check"
                    alt="logo"
                />

                <h2>
                    Thank you for your interest in partnering with David’s
                    Bridal Frontline Fierce Philanthropy Program.{" "}
                </h2>

                <p>
                    If your organization is a fit for our corporate philanthropy
                    initiative, a representative from David’s Bridal will
                    contact you regarding next steps. Thank you!
                </p>
            </div>
        </div>
    );
}

export function Philanthropy() {
    const [confirmed, setConfirmed] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    utag.view({ page_name: "db | philanthropy | home" });
    const onSubmit = (data) => {
        setConfirmed(true);
        utag.link({
            event_action: "philanthropy form submit",
        });
        // Translate to CRM fields
        const reqBody = {
            firstname: data.FirstName,
            lastname: data.LastName,
            emailaddress1: data.EmailAddress,
            telephone1: data.PhoneNumber,
            jobtitle: data.Role,
            companyname: data.CompanyName,
            websiteurl: data.CompanyWebsite,
            address1_city: data.City,
            address1_stateorprovince: data.State,
            address1_postalcode: data.Zip,
            new_tax_exempt: data.TaxExempt,
            new_beneficiaries: data.Beneficiaries,
            new_donation_percentage: data.DonationPercentage,
            subject: "Philanthropy Signup",
        };
        makeRequest(reqBody);
    };

    return (
        <div className="vendor-form">
            {confirmed ? (
                <PhilanthropyConfirmation />
            ) : (
                <form onSubmit={handleSubmit(onSubmit)} id="pearl-vendor-form">
                    <h2 className="header-title">Charity Request Form</h2>
                    <p className="subtitle-text">
                        At David's Bridal, we share a commitment to giving back
                        and helping the community. We fulfill this mission
                        through partnering directly with nonprofit organizations
                        to provide monetary donations, merchandise, or services
                        to those in need. Through these combined efforts, we
                        have contributed more than $1 million to worthy causes
                        over the last 5 years. If your nonprofit organization is
                        interested in applying for a donation from David's
                        Bridal, we invite you to submit the following form. All
                        applicants and recipients must be classified as
                        tax-exempt under Section 501(c)(3) of the U.S. Internal
                        Revenue Code. Only organizations with this designation
                        will be considered. We are unable to provide assistance
                        directly to individuals.
                    </p>
                    <h2 className="form-section-labels">Contact Information</h2>
                    <div className="form-row">
                        <input
                            type="text"
                            placeholder="First Name"
                            {...register("FirstName", {
                                required: "First Name is required",
                                maxLength: 30,
                            })}
                        />
                        <input
                            type="text"
                            placeholder="Last Name"
                            {...register("LastName", {
                                required: "Last Name is required",
                                maxLength: 30,
                            })}
                        />
                    </div>
                    <div className="form-row">
                        <input
                            type="text"
                            placeholder="Email Address"
                            {...register("EmailAddress", {
                                required: true,
                                pattern: /^\S+@\S+$/i,
                            })}
                        />
                        <input
                            type="tel"
                            placeholder="Phone Number"
                            {...register("PhoneNumber", {
                                required: true,
                                maxLength: 12,
                            })}
                        />
                    </div>
                    <div className="form-row">
                        <input
                            type="text"
                            placeholder="Your Role/Title"
                            {...register("Role", {
                                required: true,
                                max: 80,
                            })}
                        />
                    </div>
                    <h2 className="form-section-labels company-info">
                        Company Information
                    </h2>
                    <div className="form-row">
                        <input
                            type="text"
                            placeholder="Company Name"
                            {...register("CompanyName", {
                                required: true,
                                max: 100,
                            })}
                        />
                        <input
                            type="text"
                            placeholder="Company Website"
                            {...register("CompanyWebsite", {
                                required: true,
                                max: 80,
                            })}
                        />
                    </div>
                    <div className="form-row">
                        <input
                            type="text"
                            placeholder="City"
                            {...register("City", { required: true, max: 77 })}
                        />
                        <div className="select-wrapper">
                            <select {...register("State", { required: true })}>
                                <option value="" disabled selected hidden>
                                    state
                                </option>
                                <option value="AL">AL</option>
                                <option value="AK">AK</option>
                                <option value="AR">AR</option>
                                <option value="AZ">AZ</option>
                                <option value="CA">CA</option>
                                <option value="CO">CO</option>
                                <option value="CT">CT</option>
                                <option value="DC">DC</option>
                                <option value="DE">DE</option>
                                <option value="FL">FL</option>
                                <option value="GA">GA</option>
                                <option value="HI">HI</option>
                                <option value="IA">IA</option>
                                <option value="ID">ID</option>
                                <option value="IL">IL</option>
                                <option value="IN">IN</option>
                                <option value="KS">KS</option>
                                <option value="KY">KY</option>
                                <option value="LA">LA</option>
                                <option value="MA">MA</option>
                                <option value="MD">MD</option>
                                <option value="ME">ME</option>
                                <option value="MI">MI</option>
                                <option value="MN">MN</option>
                                <option value="MO">MO</option>
                                <option value="MS">MS</option>
                                <option value="MT">MT</option>
                                <option value="NC">NC</option>
                                <option value="NE">NE</option>
                                <option value="NH">NH</option>
                                <option value="NJ">NJ</option>
                                <option value="NM">NM</option>
                                <option value="NV">NV</option>
                                <option value="NY">NY</option>
                                <option value="ND">ND</option>
                                <option value="OH">OH</option>
                                <option value="OK">OK</option>
                                <option value="OR">OR</option>
                                <option value="PA">PA</option>
                                <option value="RI">RI</option>
                                <option value="SC">SC</option>
                                <option value="SD">SD</option>
                                <option value="TN">TN</option>
                                <option value="TX">TX</option>
                                <option value="UT">UT</option>
                                <option value="VT">VT</option>
                                <option value="VA">VA</option>
                                <option value="WA">WA</option>
                                <option value="WI">WI</option>
                                <option value="WV">WV</option>
                                <option value="WY">WY</option>
                            </select>
                        </div>
                        <input
                            type="number"
                            placeholder="Zip"
                            {...register("Zip", {
                                required: true,
                                pattern: /^[0-9]{5}(?:-[0-9]{4})?$/i,
                            })}
                        />
                    </div>
                    <div className="form-row">
                        <div id="tax-agreement-wrapper">
                            <input
                                type="checkbox"
                                id="tax-exempt"
                                name="tax-exempt"
                                value="true"
                                {...register("TaxExempt", {
                                    required: false,
                                })}
                            />
                            <label id="tax-exempt-label" htmlFor="tax-exempt">
                                My organization is a 501(c)(3) tax-exempt public
                                charity
                            </label>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="row-wrapper">
                            <p className="subtitle-text">
                                Donation percentage (the percentage of money
                                actually going to charity)
                            </p>
                            <input
                                type="number"
                                className="donation-percentage-input"
                                placeholder="0"
                                {...register("DonationPercentage", {
                                    required: true,
                                    min: 1,
                                    max: 100,
                                })}
                            />
                            <span>%</span>
                        </div>
                        <div className="row-wrapper">
                            <p className="subtitle-text">
                                Who are the beneficiaries for your organization?
                                (i.e.: active military, veterans, first
                                responders, teachers, etc.)
                            </p>
                            <input
                                type="text"
                                {...register("Beneficiaries", {
                                    required: true,
                                    maxLength: 260,
                                })}
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <p className="subtitle-text submit-agreement">
                            By clicking “Submit” I agree to participate in
                            periodic surveys or questionnaires received at the
                            information I have entered above and I further
                            understand and agree that my interactions with
                            David’s Bridal shall be governed by the [Terms] and
                            [Privacy] policies available therein.
                        </p>
                    </div>
                    <div className="form-row">
                        <input id="button" type="submit"></input>
                    </div>
                    <div className="form-row">
                        <p className="subtitle-text">
                            For more details, see{" "}
                            <a
                                href="https://www.davidsbridal.com/Content_Legal_terms"
                                target="_blank"
                                rel="noreferrer"
                            >
                                terms & conditions
                            </a>
                        </p>
                    </div>
                </form>
            )}
        </div>
    );
}
